import { momentOfStored } from '../../utils/dateBounds';
import { formatDuration } from '../../utils/dateDisplay';

/**
 * How long a date RANGE is ("3 days", "2h 15m"), under its END field on the
 * entry form (KPR-626, the owner's k01). The form draws a range as two fields,
 * each with its own label, place and width; this is the one thing the pair
 * still says together there, and it says it where the span closes. Nothing
 * when either half is empty or the end is before the start (the end's own
 * field already says why).
 */
export default function RangeSpanHint( { start, end, values } ) {
	const mode = start?.dataType;
	const startValue = values?.[ start?.name ];
	const endValue = values?.[ end?.name ];
	const from = momentOfStored( mode, startValue );
	const duration = formatDuration( from, momentOfStored( mode, endValue, from ), mode );
	if ( ! duration ) return null;
	return <div className='range-span-hint' data-testid='range-duration'>{duration}</div>;
}
